// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // API_URL: 'http://38.242.244.25:8000',
    API_URL: 'https://admin.lenshub.cm',
    TOKEN_KEY: 'zfvdiovfrrqytfugihoddtugfhojpv',
    CASHIER_INFOS: 'zfvdiovfrrqytsgihoddtugfhojpv',
    pageTitle: 'LENS HUB',
    firebaseConfig : {
        apiKey: "AIzaSyAunVWhjhEbuNwBnAEjRIza5tFBZjUTpWE",
        authDomain: "lenshub-19d12.firebaseapp.com",
        projectId: "lenshub-19d12",
        storageBucket: "lenshub-19d12.firebasestorage.app",
        messagingSenderId: "460874403835",
        appId: "1:460874403835:web:f9df83f8b986afcde7855e",
        measurementId: "G-87Z3VZ0GXZ"
    }
};
